import { useLockCustomer, useUnlockCustomer } from 'api/Customers'
import React from 'react'
import {
  ApiErrorNotification,
  Notification,
  useNotificationContext,
} from 'ui/components/Notification'
import { Text } from 'ui/components/Text'
import { ConfirmationModal } from 'ui/Modal'
import { useAnalytics } from 'utilities/analytics'

interface LockConfirmationProps {
  clientId: string | null
  onClose: () => void
  state: 'locking' | 'unlocking'
}
export const LockConfirmation: React.FC<LockConfirmationProps> = (props) => {
  const { isLoading: isLocking, mutate: lock } = useLockCustomer()
  const { isLoading: isUnlocking, mutate: unlock } = useUnlockCustomer()
  const notifications = useNotificationContext()
  const { fireEvent } = useAnalytics()

  const mutationOptions = {
    onSuccess: () => {
      const keyword = props.state === 'locking' ? 'locked' : 'unlocked'
      notifications.notify(
        <Notification
          title={`Customer ${keyword}`}
          description={`The customer was successfully ${keyword}`}
          variant="success"
          autoDismiss
        />
      )

      props.onClose()
    },
    onError: (e: any) => {
      notifications.notify(<ApiErrorNotification error={e} />)

      props.onClose()
    },
  }
  const handleConfirm = () => {
    if (props.state === 'locking') {
      lock(props.clientId, mutationOptions)

      fireEvent('lock_resource', {
        resource: 'client',
      })
    } else if (props.state === 'unlocking') {
      unlock(props.clientId, mutationOptions)

      fireEvent('unlock_resource', {
        resource: 'client',
      })
    }
  }

  return (
    <ConfirmationModal
      isOpen={props.clientId !== null}
      title={props.state === 'locking' ? 'Lock customer' : 'Unlock customer'}
      onClose={() => props.onClose()}
      confirmButtonLabel={props.state === 'locking' ? 'Lock' : 'Unlock'}
      onConfirm={handleConfirm}
      confirming={isLocking || isUnlocking}
      variant="warning"
    >
      {props.state === 'locking' ? (
        <div className="space-y-4">
          <Text type="caption">Are you sure you want to lock this customer?</Text>
          <Text type="caption">
            When locked, the personal information of this customer won't be able to be modified.
          </Text>
          <Text type="caption">
            Only a user with the required permission can unlock a customer.
          </Text>
        </div>
      ) : (
        <div className="space-y-4">
          <Text type="caption">Are you sure you want to unlock this customer?</Text>
          <Text type="caption">
            When unlocked, the personal information of this customer will be able to be modified.
          </Text>
        </div>
      )}
    </ConfirmationModal>
  )
}
